import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="alert"
export default class extends Controller {
  static targets = ["alert"];

  connect() {
    this.showAlert();
    this.autoDismiss();
  }

  showAlert() {
    setTimeout(() => {
      this.alertTarget.classList.remove("opacity-0");
      this.alertTarget.style.marginTop = "1rem";
    }, 100);
  }

  autoDismiss() {
    setTimeout(() => {
      this.dismiss();
    }, 5000);
  }

  dismiss() {
    this.alertTarget.classList.add("opacity-0");
    this.alertTarget.style.marginTop = "-4rem";
    setTimeout(() => {
      this.alertTarget.remove();
    }, 500);
  }
}
